import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Input } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { usePrevious } from '@hooks';
export const DisplayNameFilter = ({ disabled, value = '', onChange }) => {
    const [displayName, setDisplayName] = useState(value);
    const previousValue = usePrevious(value);
    const handleOnChange = useCallback((e) => {
        setDisplayName(e.target.value);
    }, []);
    const handleOnSearch = useCallback(() => {
        onChange({ objectNameFilter: displayName });
    }, [displayName, onChange]);
    useEffect(() => {
        if (displayName && previousValue && !value) {
            setDisplayName('');
        }
    }, [displayName, previousValue, value]);
    return React.createElement(Input.Search, { allowClear: true, className: 'display-name-filter', disabled: disabled, onBlur: handleOnSearch, onChange: handleOnChange, onPressEnter: handleOnSearch, onSearch: handleOnSearch, placeholder: COPY_SPECIFIC.DISPLAY_NAME, value: displayName });
};
